import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconDelete(props: IconContainerProps) {
    return <IconContainer size={props.size} color="red">
        delete
    </IconContainer>
}
